// extracted by mini-css-extract-plugin
export default {"root":"IconSignIn_root__2X7H8"};